import { render, staticRenderFns } from "./utility-belt.vue?vue&type=template&id=6a0c3a67&"
import script from "./utility-belt.vue?vue&type=script&lang=js&"
export * from "./utility-belt.vue?vue&type=script&lang=js&"
import style0 from "./utility-belt.vue?vue&type=style&index=0&id=6a0c3a67&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports